import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import {
  PatientCentralRefDataConsumerRenderProps,
  withPatientCentralRefDataContext
} from 'components/patient-entry/PatientCentralRefDataContext';
import moment from 'moment';
import React from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Table } from 'semantic-ui-react';
import styled from 'styled-components';
import { InterventionBookingStatus } from 'ts-types/api.enums';
import { InterventionBookingHistoryDto, TestKitReceptionOptionDto } from 'ts-types/api.types';

const ResultsPane = styled.div`

  width: max-content;

  .booking-history-header {
    font-weight: bold;
    font-size: 1.1rem;
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .booking-history-container {
    //display: grid;
    //grid-template-columns: minmax(min-content, max-content) minmax(3.5rem, max-content) minmax(3.5rem, max-content);
    //row-gap: 0.35rem;
    //column-gap: 1.2rem;
    display: flex;
    flex-direction: column;

    .history-row {
      display: grid;
      grid-column-gap: 1.5rem;
      grid-template-columns: minmax(0, 7.5rem) minmax(0, 1fr) minmax(0, 1fr);
      margin-bottom: .2rem;

      .status-col {
        padding-right: 1.5rem;
        color: #575757;
      }

      .user-col {
        padding-right: 1.5rem;
      }

      .user-col.not-available {
        font-size: 1rem;
        color: #444;
        font-style: italic;
      }

      .datetime-col {
      }

      .datetime-col.no-result {
        color: #a5a5a5;
      }
    }
  }

`;

export interface BookingHistoryViewProps extends MessageSourceProps,
    PatientCentralRefDataConsumerRenderProps,
    AuthConsumerRenderProps {

  bookingHistory: Array<InterventionBookingHistoryDto>,
  currentStatus: string,
  testKitReceptionOptionId?: number
}

const BookingHistoryView = (props: BookingHistoryViewProps) => {

  const {
    bookingHistory,
    currentStatus,
    testKitReceptionOptionId,
    getTestKitReceptionOptionById,
    language,
    getMessage
  } = props;

  const testKitReceptionOptionDescription = (testKitReception: TestKitReceptionOptionDto | undefined): string => {

    if (!testKitReception) {
      return "";
    }

    const texts: { [key: string]: string } = {
      "de": testKitReception.description,
      "en": testKitReception.descriptionEn,
      "fr": testKitReception.descriptionFr,
      "it": testKitReception.descriptionIt
    };
    return texts[language] || testKitReception.description;
  };

  if (bookingHistory.length < 1) {
    return (
        <ResultsPane>
          <div className="booking-history-header">{getMessage("patientCentral.booking.history.title")}</div>
          <div className="booking-history-container">
            <div className="status-col">
              {getMessage(`enum.interventionBookingStatus.${currentStatus}`)}
            </div>
          </div>
        </ResultsPane>
    );
  }
  return (
      <ResultsPane>
        <div className="booking-history-header">{getMessage("patientCentral.booking.history.title")}</div>
        <Table basic="very">
          <Table.Body>
            {bookingHistory.map(history => {
              let testKitReceptionDescription = null;
              if (testKitReceptionOptionId && history.status === InterventionBookingStatus.LAB_RECEIVED) {
                const testKitReceptionOption = getTestKitReceptionOptionById(testKitReceptionOptionId);
                if (testKitReceptionOption) {
                  testKitReceptionDescription = testKitReceptionOptionDescription(testKitReceptionOption);
                }
              }
              return (
                  <Table.Row key={history.id}>
                    <Table.Cell>
                      {getMessage(`enum.interventionBookingStatus.${history.status}`)}
                      {testKitReceptionDescription && ` (${testKitReceptionDescription})`}
                    </Table.Cell>
                    {history.userFirstName || history.userLastName ?
                        <Table.Cell>
                          {history.userLastName && history.userLastName} &nbsp;
                          {history.userFirstName && history.userFirstName}
                        </Table.Cell>
                        : null
                    }
                    <Table.Cell>
                      {moment(history.changeTime).format("DD.MM.YYYY HH:mm")}
                    </Table.Cell>
                  </Table.Row>
              );
            }).reverse()
            }
          </Table.Body>
        </Table>
      </ResultsPane>
  );
};

export default withMessages(withPatientCentralRefDataContext(withAuthContext(BookingHistoryView)));
